import React, { ReactNode } from 'react';

// styles
import * as Styled from 'shared/_styles/EmptyStateCard.style';
import * as Text from 'theme/components/Text.style';

interface EmptyStateCardProps {
  subtitle?: string;
  title: string;
  action?: ReactNode;
}

export default function EmptyStateCard({
  subtitle,
  title,
  action,
}: EmptyStateCardProps): JSX.Element {
  return (
    <Styled.Card>
      <Text.P2Bold>{title}</Text.P2Bold>
      {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
      {action && <Styled.Action>{action}</Styled.Action>}
    </Styled.Card>
  );
}
